import { Link } from 'react-router-dom';

interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumb({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs text-foreground-500">
      {items.map((item, index) => {
        const isLast = index === items.length - 1;
        return (
          <span key={`${item.label}-${index}`} className="flex items-center gap-2">
            {item.to && !isLast ? (
              <Link to={item.to} className="hover:text-primary-700 transition-colors cursor-pointer">
                {item.label}
              </Link>
            ) : (
              <span className={isLast ? 'text-foreground-800' : ''}>{item.label}</span>
            )}
            {!isLast && <i className="ri-arrow-right-s-line text-foreground-300" aria-hidden="true"></i>}
          </span>
        );
      })}
    </nav>
  );
}